import { groupListDtoToGroup, UserListDtoToUserList, UserDtoToCreateUser, } from '../../mappers/groups';
import { removesSpecialCharacters } from '../../utils/formaters';
import { api } from './api';
export const GroupsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getUserList: builder.query({
            query: params => ({
                method: 'get',
                url: 'api/usuariopdc/obtertodos',
                params: {
                    tamanhoPagina: params.quantity || 5,
                    indicePagina: params.page || 1,
                    filtro: params.term || null,
                    codigoBase: params.filter || null,
                },
                providesTags: ['Access'],
            }),
            transformResponse: (response) => UserListDtoToUserList(response),
        }),
        getUser: builder.query({
            query: cpf => ({
                method: 'get',
                url: `api/usuariopdc/obterporcpf/${removesSpecialCharacters(cpf)}`,
                providesTags: ['Access'],
            }),
            transformResponse: (response) => UserDtoToCreateUser(response),
        }),
        getGroupList: builder.query({
            query: () => ({
                method: 'get',
                url: 'api/grupousuario',
            }),
            transformResponse: (response) => groupListDtoToGroup(response || []),
        }),
        createUser: builder.mutation({
            query: ({ email, cpf, permissions, phone, date, bases, name }) => ({
                method: 'post',
                url: 'api/usuariopdc/criar',
                data: {
                    cpf: removesSpecialCharacters(cpf),
                    email,
                    nome: name,
                    dataNascimento: date,
                    telefone: removesSpecialCharacters(phone || ''),
                    gruposEconomicos: bases,
                    codigosPermissoes: permissions,
                },
            }),
            invalidatesTags: ['Access'],
        }),
        editUser: builder.mutation({
            query: ({ email, cpf, permissions, phone, date, bases, name }) => ({
                method: 'post',
                url: 'api/usuariopdc/editar',
                data: {
                    cpf: removesSpecialCharacters(cpf),
                    email,
                    nome: name,
                    dataNascimento: date,
                    telefone: removesSpecialCharacters(phone || ''),
                    gruposEconomicos: bases,
                    codigosPermissoes: permissions,
                },
            }),
            invalidatesTags: ['Access'],
        }),
        deleteUser: builder.mutation({
            query: cpf => ({
                method: 'delete',
                url: `api/usuariopdc/deletar/${removesSpecialCharacters(cpf)}`,
            }),
            invalidatesTags: ['Access'],
        }),
    }),
});
export const { useDeleteUserMutation, useEditUserMutation, useGetGroupListQuery, useLazyGetUserQuery, useLazyGetUserListQuery, useCreateUserMutation, } = GroupsApi;
